import React, { useState, useEffect } from 'react'

export default function FixWidthContainer({
  children,
  display = 'flex',
  flexDirection = 'column',
  alignItems = 'space-between',
  justifyContent = 'space-between',
  width = '65%',
}) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div
      style={{
        display: display,
        alignItems: alignItems,
        flexDirection: flexDirection,
        justifyContent: justifyContent,
        width: isMobile ? '95%' : width,
        margin: '0 auto',
      }}
    >
      {children}
    </div>
  )
}
